<template>
    <div v-if="state.isLoading" class="spinner_wrap">
        <div class="spinner"></div>
    </div>
</template>

<script lang="ts">
    import { reactive, watch } from "vue";

    export default {
        props: ["isLoading"],
        setup(props: any) {
            const state = reactive({
                isLoading: true as boolean,
            });
            watch(props, () => {
                state.isLoading = props.isLoading;
            });
            return {
                state,
            };
        },
    };
</script>

<style scoped>
    .spinner_wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px 0;
        width: 100%;
        height: auto;
    }

    .spinner {
        border: 6px solid rgba(169, 169, 169, 0.3);
        border-top: 6px solid #3498db;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>
